import React, { useState, ReactNode, forwardRef, RefCallback } from 'react';

interface NumberTextBoxProps {
    label?: string;
    required?: boolean;
    name: string;
    icon?: ReactNode;
    placeholder?: string;
    value?: string | number;
    type: string;
    handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    error?: string;
    touched?: boolean;
    login?: boolean;
    disabled?: boolean;
    doubleClick?: () => void;
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
    onPlusClick?: () => void;  // New prop for handling '+' click
    onMinusClick?: () => void; // New prop for handling '-' click
}

const NumberTextBox = forwardRef<HTMLInputElement, NumberTextBoxProps>((props, ref) => {
    const showError = props.touched && !!props.error;

    return (
        <div className="block text-[12px] w-full">
            {props.label && (
                <div className="flex flex-row mb-0.5">
                    <label
                        className="block font-normal text-cyan-900 dark:text-gray-200 font-public-sans"
                        htmlFor={props.name}
                    >
                        {props.label}
                    </label>
                    {props.required && <span className="text-red-500 pl-1">*</span>}
                </div>
            )}
            <div className={`flex items-center ring-[1px] select-none ring-gray-200 dark:ring-sky-900 rounded-sm text-default-500 text-sm font-normal bg-background transition duration-300 
                `}>
                <div
                    className="flex items-center justify-center select-none text-gray-600 dark:text-gray-400 px-2 cursor-pointer"
                    onClick={props.onMinusClick}
                >
                    -
                </div>
                <input
                    type={props.type}
                    className={`placeholder:text-[11.5px] font-normal placeholder:select-none
                         placeholder:font-light dark:bg-transparent dark:text-gray-300 
                         placeholder:text-gray-300 placeholder:dark:text-gray-500 text-slate-600 text-[12px] font-public-sans w-full focus:outline-none 
                        ${showError ? "!ring-[1px] px-2 !ring-red-600 shadow-sm py-[2.5px] rounded-sm" :
                            "px-2 shadow-sm py-[2.5px] ring-[1px] ring-gray-200 dark:ring-sky-900 rounded-sm focus:ring-1 dark:focus:ring-green-400 focus:ring-green-600"}`}
                    id={props.name}
                    name={props.name}
                    disabled={props.disabled || true}
                    autoCapitalize="off"
                    autoComplete="off"
                    value={props.value}
                    ref={ref as React.RefCallback<HTMLInputElement>}
                    onChange={props.handleChange || (() => { })}
                    onBlur={(e) => {
                        props.handleBlur && props.handleBlur(e);
                    }}
                    onDoubleClick={props.doubleClick}
                    onWheel={(e) => e.currentTarget.blur()}
                    {...props.inputProps}
                    onKeyPress={props.onKeyPress}
                    placeholder={props.placeholder}
                    required={props.required}
                />
                <div
                    className="flex items-center justify-center text-gray-600 dark:text-gray-400 px-2 cursor-pointer"
                    onClick={props.onPlusClick}
                >
                    +
                </div>

            </div>
            {showError && <p className="text-red-500 text-[10px] mt-0.5">{props.error}</p>}
        </div>
    );
});

export default NumberTextBox;
